import type { HolterConfigureData } from '@common/validation/customControls/cardiology/holter/holterConfigureSchemas';
import { HardwareProcessStatus } from '@common/enums/hardwareProcessStatus';

export const holterConfigureInitialData: HolterConfigureData = {
    configurationDatetime: undefined,
    desktopProcessId: undefined,
    hasDesktopProcessTimedOut: false,
    holterPublicKey: undefined,
    holterSerialNumber: undefined,
    holterToken: undefined,
    isProcessing: false,
    preparationValue: undefined,
    processError: null,
    processStatus: HardwareProcessStatus.starting,
    recorderType: undefined,
};
